import { useScroll } from '../../hooks/useScroll';
import { useLanguage } from '../../hooks/useLanguage';
import { trackEvent } from '../../utils/analytics';
import '../../styles/components/Hero.css';

const Hero = () => {
  const { scrollToSection } = useScroll();
  const { t } = useLanguage();

  const handleCtaClick = () => {
    trackEvent('cta_click', { cta: 'hero_contact', location: 'hero' });
    scrollToSection('contact');
  };

  return (
    <section id='home' className='hero'>
      <div className='hero-animated-bg' />
      <div className='hero-overlay' />

      <div className='hero-center'>
        <h1 className='hero-title'>{t.hero.title}</h1>
        <p className='hero-subtitle'>{t.hero.subtitle}</p>
        <button className='hero-cta' onClick={handleCtaClick}>
          {t.hero.cta}
        </button>
      </div>
    </section>
  );
};

export default Hero;
